export default function StatusIndicator({ status }: { status: string }) {
  const isOnline = status === "online";

  return (
    <span
      className={`flex h-6 w-6 items-center justify-center rounded-full sm:h-7 sm:w-7 ${
        isOnline ? "bg-green-500" : "bg-red-500"
      }`}
    >
      <i
        className={`text-[16px] text-white ${
          isOnline ? "ri-check-line" : "ri-close-line"
        }`}
      />
    </span>
  );
}
